module.exports = __webpack_public_path__ + "static/img/down_btn2.977f1c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn2.png
// module id = x1WR
// module chunks = 4